var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
const initHotspotSlider = /* @__PURE__ */ __name(($el, $hotspotEl) => {
  const state = window.Alpine.reactive({
    element: $el,
    hotspotElement: $hotspotEl
  });
  const renderHotspotContent = /* @__PURE__ */ __name(async (el, hotspotEl) => {
    const hotspotImage = document.querySelector("[data-mobile-hotspot-image]");
    const hotspotItems = document.querySelectorAll("[data-hotspot-items] [data-hotspot-item]");
    el.innerHTML = "";
    hotspotEl.innerHTML = "";
    if (hotspotImage) {
      const image = hotspotImage?.cloneNode(true);
      hotspotEl.appendChild(image);
    }
    hotspotItems?.forEach((item, index) => {
      item.setAttribute("data-hotspot-active", "false");
      const hotspotItem = item?.cloneNode(true);
      hotspotEl.appendChild(hotspotItem);
      if (!item.hasAttribute("data-intersected")) {
        item.setAttribute("data-intersected", "true");
      }
      const card = item.querySelector("[data-style-hotspot-card")?.cloneNode(true);
      if (card) {
        el.appendChild(card);
      } else {
        console.error("Failed to find or clone [data-style-hotspot-card] for item:", item);
      }
    });
  }, "renderHotspotContent");
  const handleScroll = /* @__PURE__ */ __name((activeIndex) => {
    document.querySelectorAll("[data-grid-slider] [data-hotspot-active]").forEach((el) => {
      el.setAttribute("data-hotspot-active", "false");
      el.dispatchEvent(new CustomEvent("hotspot-update", { bubbles: true }));
    });
    const activeElement = document.querySelector(`[data-grid-slider] [data-hotspot-item="${activeIndex}"]`);
    if (activeElement) {
      activeElement.setAttribute("data-hotspot-active", "true");
      activeElement.dispatchEvent(new CustomEvent("hotspot-update", { bubbles: true }));
    }
  }, "handleScroll");
  return new Promise((resolve) => {
    renderHotspotContent($el, $hotspotEl).then(() => {
      resolve({
        state,
        renderHotspotContent,
        handleScroll
      });
    });
  });
}, "initHotspotSlider");
window._sections["initHotspotSlider"] = initHotspotSlider;
